module.exports = __webpack_public_path__ + "img/pro-head-photo3.c2f35683.jpg";